import { useEffect, useState } from 'react';
import { PageActionsProps } from '@shopify/polaris';
import { useApp } from '@context/app';

type UsePageActions = {
  primary?: PageActionsProps['primaryAction'];
  secondary?: PageActionsProps['primaryAction'];
  others?: PageActionsProps['secondaryActions'];
};

const usePageActions = (
  {
    primary = {
      disabled: true,
    },
    secondary = {
      content: 'Discard',
      disabled: false,
    },
    others = [],
  }: UsePageActions,
  deeps: any[] = [],
) => {
  const { updatePageActions } = useApp();
  const [disablePrimary, setDisablePrimary] = useState(primary?.disabled);
  const [disableSecondary, setDisableSecondary] = useState(secondary?.disabled);
  useEffect(() => {
    updatePageActions &&
      updatePageActions({
        primaryAction: {
          ...primary,
          disabled: disablePrimary,
        },
        secondaryActions: [
          {
            ...secondary,
            disabled: disableSecondary,
          },
          ...others,
        ],
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deeps, disablePrimary, disableSecondary]);

  return {
    disablePrimaryAction: setDisablePrimary,
    disableSecondaryAction: setDisableSecondary,
  };
};

export const useShowPageActions = (deeps: any[] = []) => {
  const { setShowPageActions } = useApp();
  useEffect(() => {
    setShowPageActions && setShowPageActions(true);
    return () => setShowPageActions && setShowPageActions(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deeps);
};

export default usePageActions;
